import { useMemo } from 'react';

import PreviewFullscreenChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewFullscreenChart';
import PreviewFwdCurveChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewFwdCurveChart';
import PreviewSeasonalChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewSeasonalChart';
import PreviewSpotChart from '@/features/DataHub/components/Preview/ChartPreviews/PreviewSpotChart';
import { useExportMeta } from '@/features/DataHub/modules/Export/context/exportContexts';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';
import { useAppSelector } from '@/hooks/redux-hooks';

const Preview = ({ showLegend = true }: { showLegend?: boolean }) => {
  const { type: exportType, from, isLightMode } = useAppSelector(state => state.export);
  const { uniqueSymbols } = useExportMeta();
  const symbols = useMemo(() => Array.from(uniqueSymbols), [uniqueSymbols]);
  if (!exportType || exportType === ExportTypes.DATA) {
    return (
      <PreviewSpotChart
        showLegend={showLegend}
        symbols={symbols}
      />
    );
  }
  if (exportType === 'fullscreen') {
    return (
      <PreviewFullscreenChart
        isLightMode={isLightMode}
        showLegend={showLegend}
        symbols={symbols}
      />
    );
  }
  if (exportType === 'spot') {
    return (
      <PreviewSpotChart
        showLegend={showLegend}
        symbols={symbols}
      />
    );
  }
  if (exportType === 'forwardSimple') {
    return <PreviewFwdCurveChart symbols={symbols} />;
  }
  if (exportType === 'seasonal') {
    return (
      <PreviewSeasonalChart
        from={from}
        symbols={symbols}
      />
    );
  }
  return null;
};
export default Preview;
